import { API_URL } from '../config';
import { buildHeaders } from './headers';

export interface Message {
  id: number;
  content: string;
  sentAt: string;
  senderId: number;
  senderName: string;
}

export interface MessageThread {
  id: number;
  title?: string;
  tournamentId?: number;
  createdAt: string;
  updatedAt: string;
  lastMessage?: {
    id: number;
    content: string;
    sentAt: string;
    senderId: number;
    senderName: string;
  };
  unreadCount: number;
}

export const getMyThreads = async (apiKey: string): Promise<MessageThread[]> => {
  const response = await fetch(`${API_URL}/api/messaging/my-threads`, {
    headers: buildHeaders(apiKey),
  });
  if (!response.ok) throw await response.json();
  return response.json();
};

export const getMessagesForThread = async (apiKey: string, threadId: number): Promise<Message[]> => {
  const response = await fetch(`${API_URL}/api/messaging/threads/${threadId}/messages`, {
    headers: buildHeaders(apiKey),
  });
  if (!response.ok) throw await response.json();
  return response.json();
};

export const postMessage = async (apiKey: string, threadId: number, content: string): Promise<Message> => {
  const response = await fetch(`${API_URL}/api/messaging/threads/${threadId}/messages`, {
    method: 'POST',
    headers: buildHeaders(apiKey),
    body: JSON.stringify({ content }),
  });
  if (!response.ok) throw await response.json();
  return response.json();
};

export const updateLastReadMessage = async (apiKey: string, threadId: number, messageId: number): Promise<void> => {
  const response = await fetch(`${API_URL}/api/messaging/threads/${threadId}/messages/${messageId}/read`, {
    method: 'POST',
    headers: buildHeaders(apiKey),
  });
  if (!response.ok) throw await response.json();
};

export const createThread = async (
  apiKey: string,
  title: string | undefined,
  tournamentId: number | undefined,
  participantUserIds: number[],
): Promise<MessageThread> => {
  const response = await fetch(`${API_URL}/api/messaging/threads`, {
    method: 'POST',
    headers: buildHeaders(apiKey),
    body: JSON.stringify({ title, tournamentId, participantUserIds }),
  });
  if (!response.ok) throw await response.json();
  return response.json();
};

export const addParticipantToThread = async (apiKey: string, threadId: number, userId: number): Promise<void> => {
  const response = await fetch(`${API_URL}/api/messaging/threads/${threadId}/participants`, {
    method: 'POST',
    headers: buildHeaders(apiKey),
    body: JSON.stringify({ userId }),
  });
  if (!response.ok) throw await response.json();
};

export const removeParticipantFromThread = async (apiKey: string, threadId: number, userId: number): Promise<void> => {
  const response = await fetch(`${API_URL}/api/messaging/threads/${threadId}/participants/${userId}`, {
    method: 'DELETE',
    headers: buildHeaders(apiKey),
  });
  if (!response.ok) throw await response.json();
};
